@let onglet = data()?.ongletDevPhysiquePhysio ?? null;

<!-- Alimentation -->
<p class="section-sub-title"><mat-icon>restaurant</mat-icon>Alimentation</p>
<div class="info-grid">
  @let items0 = getVisibleItems(onglet?.radio_diversification, diversificationStatutLabels, 'radio_diversification');
  @if (items0.length) {
  <span class="label">Diversification</span>
  <span class="value chips-row">
    @for (re of items0; track re.key) {
    @let firstDA = getFirstDate('radio_diversification', re.key);
    <mat-chip class="chip-small" [class.chip-has-firstda]="firstDA" #tt="matTooltip"
      [matTooltip]="firstDA ? 'Depuis le ' + formatFirstDate(firstDA) : ''"
      matTooltipPosition="above" (click)="firstDA && tt.show()">{{ re.label }}</mat-chip>
    }
  </span>
  }
  @let items1 = getVisibleItems(onglet?.radio_typeRepas, typeRepasLabels, 'radio_typeRepas');
  @if (items1.length) {
  <span class="label">Type de repas</span>
  <span class="value chips-row">
    @for (re of items1; track re.key) {
    @let firstDA = getFirstDate('radio_typeRepas', re.key);
    <mat-chip class="chip-small" [class.chip-has-firstda]="firstDA" #tt="matTooltip"
      [matTooltip]="firstDA ? 'Depuis le ' + formatFirstDate(firstDA) : ''"
      matTooltipPosition="above" (click)="firstDA && tt.show()">{{ re.label }}</mat-chip>
    }
  </span>
  }
  @let items2 = getVisibleItems(onglet?.radio_texture, textureLabels, 'radio_texture');
  @if (items2.length) {
  <span class="label">Texture</span>
  <span class="value chips-row">
    @for (re of items2; track re.key) {
    @let firstDA = getFirstDate('radio_texture', re.key);
    <mat-chip class="chip-small" [class.chip-has-firstda]="firstDA" #tt="matTooltip"
      [matTooltip]="firstDA ? 'Depuis le ' + formatFirstDate(firstDA) : ''"
      matTooltipPosition="above" (click)="firstDA && tt.show()">{{ re.label }}</mat-chip>
    }
  </span>
  }
  @let items3 = getVisibleItems(onglet?.radio_quantiteRepas, quantiteRepasLabels, 'radio_quantiteRepas');
  @if (items3.length) {
  <span class="label">Quantité / repas</span>
  <span class="value chips-row">
    @for (re of items3; track re.key) {
    @let firstDA = getFirstDate('radio_quantiteRepas', re.key);
    <mat-chip class="chip-small" [class.chip-has-firstda]="firstDA" #tt="matTooltip"
      [matTooltip]="firstDA ? 'Depuis le ' + formatFirstDate(firstDA) : ''"
      matTooltipPosition="above" (click)="firstDA && tt.show()">{{ re.label }}</mat-chip>
    }
  </span>
  }
  @let items4 = getVisibleItems(onglet?.radio_legumeFeculent06, legumeFeculent06Labels, 'radio_legumeFeculent06');
  @if (items4.length) {
  <span class="label">Légume / féculent (0–6 mois)</span>
  <span class="value chips-row">
    @for (re of items4; track re.key) {
    @let firstDA = getFirstDate('radio_legumeFeculent06', re.key);
    <mat-chip class="chip-small" [class.chip-has-firstda]="firstDA" #tt="matTooltip"
      [matTooltip]="firstDA ? 'Depuis le ' + formatFirstDate(firstDA) : ''"
      matTooltipPosition="above" (click)="firstDA && tt.show()">{{ re.label }}</mat-chip>
    }
  </span>
  }
  @let items5 = getVisibleItems(onglet?.radio_legumeFeculent6plus, legumeFeculent6plusLabels, 'radio_legumeFeculent6plus');
  @if (items5.length) {
  <span class="label">Légume / féculent (6+ mois)</span>
  <span class="value chips-row">
    @for (re of items5; track re.key) {
    @let firstDA = getFirstDate('radio_legumeFeculent6plus', re.key);
    <mat-chip class="chip-small" [class.chip-has-firstda]="firstDA" #tt="matTooltip"
      [matTooltip]="firstDA ? 'Depuis le ' + formatFirstDate(firstDA) : ''"
      matTooltipPosition="above" (click)="firstDA && tt.show()">{{ re.label }}</mat-chip>
    }
  </span>
  }
  @let items6 = getVisibleItems(onglet?.radio_lait, laitLabels, 'radio_lait');
  @if (items6.length) {
  <span class="label">Lait</span>
  <span class="value chips-row">
    @for (re of items6; track re.key) {
    @let firstDA = getFirstDate('radio_lait', re.key);
    <mat-chip class="chip-small" [class.chip-has-firstda]="firstDA" #tt="matTooltip"
      [matTooltip]="firstDA ? 'Depuis le ' + formatFirstDate(firstDA) : ''"
      matTooltipPosition="above" (click)="firstDA && tt.show()">{{ re.label }}</mat-chip>
    }
  </span>
  }
  @let items7 = getVisibleItems(onglet?.radio_temperature, temperatureLabels, 'radio_temperature');
  @if (items7.length) {
  <span class="label">Température du lait</span>
  <span class="value chips-row">
    @for (re of items7; track re.key) {
    @let firstDA = getFirstDate('radio_temperature', re.key);
    <mat-chip class="chip-small" [class.chip-has-firstda]="firstDA" #tt="matTooltip"
      [matTooltip]="firstDA ? 'Depuis le ' + formatFirstDate(firstDA) : ''"
      matTooltipPosition="above" (click)="firstDA && tt.show()">{{ re.label }}</mat-chip>
    }
  </span>
  }
  @let items8 = getVisibleItems(onglet?.radio_biberon, biberonLabels, 'radio_biberon');
  @if (items8.length) {
  <span class="label">Biberon</span>
  <span class="value chips-row">
    @for (re of items8; track re.key) {
    @let firstDA = getFirstDate('radio_biberon', re.key);
    <mat-chip class="chip-small" [class.chip-has-firstda]="firstDA" #tt="matTooltip"
      [matTooltip]="firstDA ? 'Depuis le ' + formatFirstDate(firstDA) : ''"
      matTooltipPosition="above" (click)="firstDA && tt.show()">{{ re.label }}</mat-chip>
    }
  </span>
  }
  @let items9 = getVisibleItems(onglet?.radio_eau, eauLabels, 'radio_eau');
  @if (items9.length) {
  <span class="label">Eau</span>
  <span class="value chips-row">
    @for (re of items9; track re.key) {
    @let firstDA = getFirstDate('radio_eau', re.key);
    <mat-chip class="chip-small" [class.chip-has-firstda]="firstDA" #tt="matTooltip"
      [matTooltip]="firstDA ? 'Depuis le ' + formatFirstDate(firstDA) : ''"
      matTooltipPosition="above" (click)="firstDA && tt.show()">{{ re.label }}</mat-chip>
    }
  </span>
  }
  @let itemsBoit = getVisibleItems(onglet?.checkbox_boit, boitLabels, 'checkbox_boit');
  @if (itemsBoit.length) {
  <span class="label">Boit avec</span>
  <span class="value chips-row">
    @for (e of itemsBoit; track e.key) {
    @let firstDA = getFirstDate('checkbox_boit', e.key);
    <mat-chip class="chip-small" [class.chip-has-firstda]="firstDA"
      #tt="matTooltip" [matTooltip]="firstDA ? 'Depuis le ' + formatFirstDate(firstDA) : ''"
      matTooltipPosition="above" (click)="firstDA && tt.show()">{{ e.label }}</mat-chip>
    }
  </span>
  }
  @let itemsMange = getVisibleItems(onglet?.checkbox_mange, mangeLabels, 'checkbox_mange');
  @if (itemsMange.length) {
  <span class="label">Mange</span>
  <span class="value chips-row">
    @for (e of itemsMange; track e.key) {
    @let firstDA = getFirstDate('checkbox_mange', e.key);
    <mat-chip class="chip-small" [class.chip-has-firstda]="firstDA"
      #tt="matTooltip" [matTooltip]="firstDA ? 'Depuis le ' + formatFirstDate(firstDA) : ''"
      matTooltipPosition="above" (click)="firstDA && tt.show()">{{ e.label }}</mat-chip>
    }
  </span>
  }
  @let itemsAutoRepas = getVisibleItems(onglet?.checkbox_autonomieRepas, autonomieRepasLabels, 'checkbox_autonomieRepas');
  @if (itemsAutoRepas.length) {
  <span class="label">Autonomie repas</span>
  <span class="value chips-row">
    @for (e of itemsAutoRepas; track e.key) {
    @let firstDA = getFirstDate('checkbox_autonomieRepas', e.key);
    <mat-chip class="chip-small" [class.chip-has-firstda]="firstDA"
      #tt="matTooltip" [matTooltip]="firstDA ? 'Depuis le ' + formatFirstDate(firstDA) : ''"
      matTooltipPosition="above" (click)="firstDA && tt.show()">{{ e.label }}</mat-chip>
    }
  </span>
  }
  @if (onglet?.input_comportementAlimentation) {
  <span class="label">Comportement</span>
  <span class="value">{{ onglet?.input_comportementAlimentation }}</span>
  }
</div>

<!-- Siestes -->
<p class="section-sub-title"><mat-icon>bedtime</mat-icon>Rythme des siestes</p>
@let itemsSieste = getVisibleItems(onglet?.radio_momentSieste, momentSiesteLabels, 'radio_momentSieste');
@if (itemsSieste.length) {
<div class="chips-block">
  @for (re of itemsSieste; track re.key) {
  @let firstDA = getFirstDate('radio_momentSieste', re.key);
  <mat-chip class="chip-small" [class.chip-has-firstda]="firstDA"
    #tt="matTooltip" [matTooltip]="firstDA ? 'Depuis le ' + formatFirstDate(firstDA) : ''"
    matTooltipPosition="above" (click)="firstDA && tt.show()">{{ re.label }}</mat-chip>
  }
</div>
}

<!-- Hygiène -->
<p class="section-sub-title"><mat-icon>clean_hands</mat-icon>Hygiène</p>
<div class="info-grid">
  @let itemsPortCouche = getVisibleItems(onglet?.radio_portCouche, portCoucheLabels, 'radio_portCouche');
  @if (itemsPortCouche.length) {
  <span class="label">Port de couche</span>
  <span class="value chips-row">
    @for (re of itemsPortCouche; track re.key) {
    @let firstDA = getFirstDate('radio_portCouche', re.key);
    <mat-chip class="chip-small" [class.chip-has-firstda]="firstDA" #tt="matTooltip"
      [matTooltip]="firstDA ? 'Depuis le ' + formatFirstDate(firstDA) : ''"
      matTooltipPosition="above" (click)="firstDA && tt.show()">{{ re.label }}</mat-chip>
    }
  </span>
  }
  @let itemsChange = getVisibleItems(onglet?.radio_change, changeLabels, 'radio_change');
  @if (itemsChange.length) {
  <span class="label">Nettoyage</span>
  <span class="value chips-row">
    @for (re of itemsChange; track re.key) {
    @let firstDA = getFirstDate('radio_change', re.key);
    <mat-chip class="chip-small" [class.chip-has-firstda]="firstDA" #tt="matTooltip"
      [matTooltip]="firstDA ? 'Depuis le ' + formatFirstDate(firstDA) : ''"
      matTooltipPosition="above" (click)="firstDA && tt.show()">{{ re.label }}</mat-chip>
    }
  </span>
  }
  @if (onglet?.input_produitSpecifique) {
  <span class="label">Produit</span>
  <span class="value">{{ onglet?.input_produitSpecifique }}</span>
  }
</div>

@let itemsHygiene = getVisibleItems(onglet?.checkbox_hygieneEnfant, hygieneEnfantLabels, 'checkbox_hygieneEnfant');
@if (itemsHygiene.length) {
<div class="chips-block" style="margin-top: 8px;">
  @for (e of itemsHygiene; track e.key) {
  @let firstDA = getFirstDate('checkbox_hygieneEnfant', e.key);
  <mat-chip class="chip-small" [class.chip-has-firstda]="firstDA"
    #tt="matTooltip" [matTooltip]="firstDA ? 'Depuis le ' + formatFirstDate(firstDA) : ''"
    matTooltipPosition="above" (click)="firstDA && tt.show()">{{ e.label }}</mat-chip>
  }
</div>
}
